import { PayloadAction } from "@reduxjs/toolkit";
import { OrderFirstStepResult } from 'entities/cards';

import { IState } from "../types/state";

const action = (state: IState, payloadAction: PayloadAction<OrderFirstStepResult>) => {
  state.orderFirstStep.data = payloadAction.payload;
};

export default action;
